import axios from "axios";
import myAppConfig from "../config";

const getMyInfo =  () => {
  try {
    const response = axios.get(
    myAppConfig.api.ENDPOINT + "/api/v1/users/get-my-info",
    { withCredentials: true }
)
    return response;
  } catch(error) {
    throw new Error("Failed to fetch user information");
  };
}

const getProfile = () => {
  try {
    const response = axios.get(
    myAppConfig.api.ENDPOINT + "/api/v1/users/get-profile",
    { withCredentials: true }
)
    return response;
  }
  catch(error) {
    throw new Error(`Bad request`);
  };
}

const updateMyInfo = (updatedData) => {
  try {
    const response = axios.put(
    myAppConfig.api.ENDPOINT + "/api/v1/users/update-my-info",
    updatedData,
    { withCredentials: true }
)

    return response;
  }
  catch(error) {
    throw new Error(`Bad request`);
  };
}

const deleteProfile = () => {
  try {
    const response = axios.delete(
    myAppConfig.api.ENDPOINT + "/api/v1/users/delete-profile",
    { withCredentials: true }
)
    return response;
  }
  catch(error) {
    throw new Error(`Bad request`);
  };
}


const DataService = {
    getMyInfo,
    getProfile,
    updateMyInfo,
    deleteProfile,
};
export default DataService;